import { cn } from "@/lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn("size-7", className)} aria-hidden>
      <rect width="32" height="32" rx="8" className="fill-[#0F172A] dark:fill-[#1E2A40]" />
      <path d="M16 7a7 7 0 0 0-7 7c0 5.2 7 11 7 11s7-5.8 7-11a7 7 0 0 0-7-7z" fill="#2563EB" />
      <circle cx="16" cy="14" r="2.6" fill="#fff" />
    </svg>
  );
}

/** Product name lives in one place so it can be rebranded easily. */
export const PRODUCT_NAME = "MarkFeed";

export function Logo({ className, light }: { className?: string; light?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <LogoMark />
      <span className={cn("text-[17px] font-semibold tracking-tight", light ? "text-white" : "text-ink")}>{PRODUCT_NAME}</span>
    </span>
  );
}
